import { Fetch, FetchAttachment,FetchAudio } from '../Models/shared/general';

//#region ======== ACTIONS ========
const actions = {
    //====== CHAT =====
    task_chat_create    : "task_chat_create",
    task_task_unread    : "task_task_unread",
    get_task_chat       : "get_task_chat",
    task_chat_update    : "task_chat_update",
    get_tasklist_chat   : "get_tasklist_chat"

};
//#endregion
  

//====== CHAT =====
export async function task_chat_create(data){
    return Fetch({ action: actions.task_chat_create, data: data });
}

export async function get_task_chat(data){
    return Fetch({ action: actions.get_task_chat, data: data });
}

export async function get_tasklist_chat(data){
    return Fetch({ action: actions.get_tasklist_chat, data: data });
}

export async function task_chat_update(data){
    return Fetch({ action: actions.task_chat_update, data: data });
}

//========= ATTACHMENT ===========
export async function chat_attachment_create(data){    
    return FetchAttachment({ data: data });
}


//========= AUDIO ===========
export async function chat_audio_create(data){    
    return FetchAudio({ data: data });
}

